//frontman shell & config statuses
export const NONE = 'none';
export const FAILED = 'failed';
export const SAVED = 'saved';
export const SAVING = 'saving';



// WEBPACK FOOTER //
// ./src/constants/FrontmanStatuses.js